<script setup lang="ts">
// import { $t } from "@/i18n";
import { useRoute, useRouter } from "vue-router";
import api from "@/api";
import { useToastStore } from "@/store/toast";
import {
	openModalRejectFile,
	openConfirmModal,
} from "../../components/modals/modalDefinitions";
import type { TFileObj } from "@/assets/js/types";
import { useTokenStore } from "@/store/token";
import { DateInstance } from "@/assets/js/dateHelper";
import { downloadFile } from "@/assets/js/helpers";

definePage({
	name: "CandidateData",
	path: "/users/:id",
});

const tokenStore = useTokenStore();
const toastStore = useToastStore();

interface IStatuses {
	aps_id: string;
	aps_name: string;
	aps_public: boolean;
}
const route = useRoute();
console.log(route.params);
const router = useRouter();

const statuses = ref<IStatuses[]>([]);
const data = ref<any>();
const fList = ref<TFileObj[]>([]);

async function getApplication() {
	try {
		let res: any = null;
		res = await (tokenStore.isUserB2B
			? api.invitesGetSingle({ app_id: route.params.id })
			: api.getApplication({ app_id: route.params.id }));

		console.log(res.data);
		data.value = res?.data?.data?.length > 0 ? res.data.data[0] : null;
	} catch (e) {
		console.log(e);
	}
}

async function applicationsAttachmentsGet() {
	try {
		const res = await api.applicationsAttachmentsGet({
			app_id: route.params.id,
		});
		console.log(res.data.data);
		fList.value = res.data.data;
	} catch (e: any) {
		console.log(e);
	}
}
async function getApplicationStatuses() {
	try {
		// @ts-expect-error
		const res = await api.getApplicationStatuses();
		console.log(res.data.data);
		statuses.value = res.data.data;
	} catch (e) {
		console.log(e);
	}
}
onMounted(async () => {
	await getApplication();
	await getApplicationStatuses();
	await applicationsAttachmentsGet();
});

// const test =  {
//             "usr_id": 41,
//             "usr_name": "Mirjana 2",
//             "aps_name": null,
//             "usr_position": "Neka titula",
//             "usr_email": "mirjana.stojadinovic@enonsolutions.com",
//             "usr_phone": "000000000",
//             "cnt_code": "rs",
//             "img_id": 5_835_252_506_601_907,
//             "app_date": "2024-01-30 ",
//             "appstatus.aps_name": null,
//             "app_portfolio": null,
//             "app_coverletter": null,
//             "app_cv": "[{\"cvc_name\":\"Basic info\",\"cvc_id\":1,\"usr_attributes\":null,\"cmp_id\":null,\"cmp_name\":null,\"rol_name\":\"super-admin\",\"rol_id\":6,\"usr_position\":\"Neka titula\",\"usr_dateofbirth\":\"1984-12-15 00:00:00\",\"cnt_code\":\"rs\",\"img_id\":5835252506601907,\"usr_email\":\"mirjana.stojadinovic@enonsolutions.com\",\"usr_aboutme\":\"Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\\r\\nasdasdasdasd\",\"usr_created\":\"2023-12-07 13:45:46\",\"usr_socialnetworks\":\"\",\"usr_id\":41,\"usr_name\":\"Mirjana 2\",\"usr_phone\":\"000000000\",\"usr_address\":\"Sid\",\"usr_employmentlength\":null},{\"cvc_name\":\"Education\",\"cvc_id\":2,\"items\":[{\"cve_id\":23,\"cve_title\":\"moja diploma\",\"cve_institution\":\"Tehnicka \",\"cve_attributes\":{\"cve_field\":\"tgtgh\",\"cve_start_date\":\"2023-12-01\",\"cve_end_date\":\"2023-12-29\",\"cve_ongoing\":0},\"cve_public\":1}]},{\"cvc_name\":\"Experience\",\"cvc_id\":3,\"items\":[{\"cve_id\":24,\"cve_title\":\"Neka titula\",\"cve_institution\":\"Enon solutions\",\"cve_attributes\":{\"cve_location\":\"BG\",\"cve_location_type\":\"NGB\",\"cve_start_date\":\"2023-12-06\",\"cve_end_date\":\"2023-12-08\",\"cve_ongoing\":0,\"cve_description\":\"frefref rthtrzh zgr5z5\"},\"cve_public\":1}]},{\"cvc_name\":\"Languages\",\"cvc_id\":4,\"items\":[{\"cve_id\":25,\"cve_title\":\"5t5t5\",\"cve_institution\":\"5g54t4\",\"cve_attributes\":null,\"cve_public\":1}]},{\"cvc_name\":\"Skills\",\"cvc_id\":5,\"items\":[{\"cve_id\":26,\"cve_title\":\"f4f43f\",\"cve_institution\":\"f4f43f\",\"cve_attributes\":null,\"cve_public\":1}]},{\"cvc_name\":\"Computer Skills\",\"cvc_id\":6,\"items\":[{\"cve_id\":27,\"cve_title\":\"4f433\",\"cve_institution\":\"4f433\",\"cve_attributes\":null,\"cve_public\":1}]}]",
//         };

function formatDate(date: string) {
	if (date) {
		return DateInstance.getFormatDTLocale(date, "DD. MMM YYYY.");
	}
}

async function changeStatus(e: any) {
	const params = {
		app_id: data.value.app_id,
		aps_id: e.aps_id,
	};
	try {
		const res = await api.setApplicationStatus(params);
		console.log(res);
		toastStore.openToastSuccess("Changed status successfully.");
	} catch (e: any) {
		console.log(e.response.data.data);
		if (e.response?.data?.data) {
			toastStore.openToastError(e.response.data.data);
		} else {
			toastStore.openToastError(e.response.data.data);
		}
	}
	await getApplication();
}

function approvedFile(e: TFileObj) {
	console.log("approvedFile");
	console.log(e);
	openConfirmModal(
		{ name: e.file_title, data: e },
		confirmApproved,
		"Approve this file ?",
	);
}

function rejectFile(e: TFileObj) {
	console.log("rejectFile");
	console.log(e);
	openModalRejectFile(e, confirm);

	// applicationsReview
	// att_status
	// att_id
}

// function open(e: TFileObj) {
// 	console.log(e);
// 	console.log("pozvati komponentu za prikaz fajlova");
// }

async function open(file: { file_title: string; file_id: number }) {
	if (!file) {
		return;
	}
	// https://204b123.mars-t.mars-hosting.com/api_v1/users/images-get/

	try {
		const res = await api.appFilesGetSingle({
			file_id: file.file_id,
			app_id: Number(route.params.id),
		});
		console.log(res.data);
		downloadFile(res.data, file.file_title);
	} catch (e) {
		console.log(e.response.data);
		// download(e.response.data, file.file_title);
	}
}

async function confirmApproved(e: TFileObj) {
	console.log("pozovi api odbijanje fajlova 'Reject file'");
	console.log(e);
	// emit("close-modal");
	const params = {
		att_status: "APPROVED",
		att_id: e.att_id,
	};
	try {
		const res = await api.applicationsReview(params);
		console.log(res.data);
		toastStore.openToastSuccess("You have successfully approved the file.");
	} catch (e) {
		console.log(e);
		toastStore.openToastError("Error");
	}

	await confirm();
}

async function getRooms() {
	void router.push({
		name: "ChatApplication",
		params: { id: route.params.id },
	});
}

async function applicationsMute(e: any) {
	console.log(e);
	try {
		const res = await api.applicationsMute({ app_id: data.value.app_id });
		console.log(res.data);
	} catch (e) {
		console.log(e);
	}
}

async function confirm() {
	// console.log('osvezi');
	// await getApplication();
	await applicationsAttachmentsGet();
}

const holderOrHavePrivilage = computed(() => {
	// tokenStore.can('evt-add') || data.usr_id_responsible === tokenStore.userData?.usr_id
	// canAddCollaborators and canAddEvent have the same condition, but will be changed in the future
	return (
		data.value.usr_id_responsible === tokenStore.userData?.usr_id ||
		tokenStore.isUserCompany ||
		tokenStore.userData?.rol_id === 3 || // "agency-admin"
		tokenStore.userData?.rol_id === 4 // "agency-worker" according to the latest
	);
});

const showChat = computed(() => {
	return (
		data.value.aps_name &&
		(data.value.aps_id === "SELE" ||
			// data.value.aps_id === "TSRL" || // izmeni ovu
			data.value.aps_id === "PREP" ||
			data.value.aps_id === "TSRL" ||
			data.value.aps_id === "EMPL" ||
			data.value.aps_id === "RJCT") &&
		(tokenStore.userData?.rol_id !== 5 ||
			data.value.usr_id_responsible === tokenStore.userData?.usr_id)
	);
});
</script>

<template lang="pug">
.candidate-data(v-if="data")
	.wrapp-cv.scroll
		.wrapp-title
			.line
			.w-t(@click="router.back()")
				.arrow-left
				.title.ml-15 {{ $t("app.application.application") }}

		cv-template(:cv1="JSON.parse(data.app_cv)")
	.wrapp-f
		.up-data
			.wrapp-data
				label {{ $t("app.companies.dateApplied") }}
				.split
					.date {{ formatDate(data.app_date) }}
			.wrapp-data(
				v-if="holderOrHavePrivilage || tokenStore.isUserCompany || tokenStore.can('app-edit')"
			)
				label {{ $t("app.companies.status") }}
				.split
					select-button(
						:status="data.aps_id ? data.aps_id : 'Created'",
						:statusName="data.aps_name ? data.aps_name : 'Created'",
						:list="statuses",
						label="aps_name",
						@change="changeStatus"
					)
			.wrapp-data(v-if="showChat")
				button(@click="getRooms")
					span {{ $t("app.myapplications.viewCommunication") }}
			.wrapp-data
				.mute
					label {{ $t("app.settings.notificationsMute") }}
					SwitchComp(v-model="data.muted", @change="applicationsMute")

		.wrapp-portifolio-data
			.section(v-if="data.app_coverletter")
				.title {{ $t("app.cv.coverLetter") }}
				.data-txt {{ data.app_coverletter }}
			.section(v-if="data.app_portfolio")
				.title {{ $t("app.cv.portfolio") }}
				a(:href="data.app_portfolio", target="_blank") {{ data.app_portfolio }}

		file-list(
			:fileList="fList",
			title="Documents",
			:showStatus="true",
			:showAction="holderOrHavePrivilage",
			:showRemove="false",
			@reject="rejectFile",
			@approved="approvedFile",
			@open="open"
		)
</template>

<style lang="scss" scoped>
.candidate-data {
	max-width: 1224px;
	border-radius: 10px;
	// border: $border;
	background: $background-color;
	padding: 0 30px 30px;
	margin-bottom: 14px;
	min-height: 100%;
	height: fit-content;
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;

	.wrapp-title {
		width: fit-content;
		margin-bottom: 30px;
		.line {
			display: block;
			// background: $gradient-line3;
			// height: 5px;
			height: 0;
			width: 100%;
			margin-bottom: 14px;
			box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);
			border-radius: 0 0 10px 10px;
		}
		.w-t {
			display: flex;
			align-items: center;
		}
		.w-t:hover {
			filter: opacity(0.7);
			cursor: pointer;
		}
		.arrow-left {
			width: 0;
			height: 0;
			border-top: 12px solid transparent;
			border-bottom: 12px solid transparent;
			border-right: 12px solid $app-accent-color1;
			display: inline-block;
			cursor: pointer;
		}
		.title {
			margin-left: 15px;
			display: inline;
			// font-family: Archivo, sans-serif;
			font-size: 16px;
			font-weight: 700;
			line-height: 17px;
			letter-spacing: 0;
			text-align: left;
			color: $text-color;
		}
	}

	.wrapp-cv {
		max-width: 710px;
		min-width: 701px;
		height: 1000px;
		overflow-y: auto;
	}
	.wrapp-f {
		width: calc(100% - 751px); // 30px for gap

		.up-data {
			margin-bottom: 56px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			.wrapp-data {
				margin-top: 20px;
				display: flex;
				align-items: center;
			}
			.split {
				margin-left: 10px;
			}
			.date {
				// font-family: Archivo, sans-serif;
				font-size: 13px;
				font-weight: 600;
				line-height: 15px;
				letter-spacing: 0;
				text-align: left;
			}
		}

		.wrapp-portifolio-data {
			.section {
				margin-bottom: 50px;
			}
			.title {
				// font-family: Archivo, sans-serif;
				font-size: 16px;
				font-weight: 700;
				line-height: 17px;
				letter-spacing: 0;
				text-align: left;
				color: $text-color;
				margin-bottom: 30px;
			}
			.data-txt {
				font-family: "Open Sans", sans-serif;
				font-size: 13px;
				font-weight: 600;
				line-height: 18px;
				letter-spacing: 0;
				text-align: left;
			}
		}
	}
	.mute {
		display: flex;
		align-items: center;
		label {
			margin-right: 20px;
		}
	}
}

@media only screen and (max-width: 1400px) {
	.candidate-data {
		flex-direction: column;
		.wrapp-f {
			width: fit-content;
		}
	}
}
</style>
